var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7913 27.9583H43.208M17.7913 38.125H33.0413M17.7913 17.7917H38.1247M55.9163 43.2083C55.9163 44.5565 55.3808 45.8495 54.4275 46.8028C53.4742 47.7561 52.1812 48.2917 50.833 48.2917H17.3542C16.0061 48.292 14.7133 48.8277 13.7603 49.7811L8.16351 55.3778C7.91113 55.6302 7.58961 55.802 7.23958 55.8716C6.88956 55.9412 6.52675 55.9055 6.19704 55.7689C5.86732 55.6324 5.5855 55.4011 5.38721 55.1044C5.18892 54.8076 5.08305 54.4588 5.08301 54.1019V12.7083C5.08301 11.3601 5.61857 10.0672 6.57188 9.11387C7.52519 8.16056 8.81816 7.625 10.1663 7.625H50.833C52.1812 7.625 53.4742 8.16056 54.4275 9.11387C55.3808 10.0672 55.9163 11.3601 55.9163 12.7083V43.2083Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.9d48377b7bf28343e1ded10aba223c4e.svg";
export { ForwardRef as ReactComponent };